<template>
    <div class="shoplog" >
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="操作人">
                        <el-input v-model="searchForm.userName" placeholder="操作人" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="操作时间">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                                        end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"  clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="操作">
                        <el-input v-model="searchForm.url" placeholder="操作" size="mini" :disabled="loading" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini" :loading="loading">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    stripe size="mini"
                    :height="tableConfig.height"
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column
                        prop="url"
                        label="操作">
                    </el-table-column>
                    <el-table-column
                        prop="userName"
                        label="操作人">
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="操作时间">
                    </el-table-column>
                    <el-table-column
                        prop="params"
                        label="参数">
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
    </div>
</template>

<script>
const HEIGHT_OFFSET = 118;
export default {
    name: "ShopLog",
    data() {
        return {
            tableConfig: {
                height: 0,
            },
            searchForm: {
                userName: "",
                timeDate: "",
                url: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
        }
    },
    methods: {
        onSearch() {
            let cond = {
                userName: this.searchForm.userName,
                url: this.searchForm.url
            };
            if(this.searchForm.timeDate){
                cond.startTime = this.searchForm.timeDate[0];
                cond.endTime = this.searchForm.timeDate[1];
            }
            this.loading = true;
            let _this = this;
            this.$axios.post("/admin/audit/search",{
                cond: cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        }
    },
    created() {
        window.addEventListener("resize", this.setTableHeight);
        this.onSearch();
    },
    mounted() {
        const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            loading.close();
        }, 500);
    },
    destroyed () {
        window.removeEventListener("resize", this.setTableHeight);
    }
}
</script>

<style scoped>

</style>